import {
    createColumnDate,
    createColumnInlineSelect,
    createColumnInput,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import store from "../../../../store";
import { callJobPosition, callOfficerLv, callOfficerType } from "../../../account/register/register.section";
import { callDocumentTypePerson, callUserStatus } from "../../company/mgt-tab/tab-4/tab4.section";

export const callDepartment = () => store.dispatch("resource/v1/master/department/cacheFindAllWithChildrenType", { type: "main" });

export const createColumns = () => {
    const columns = [
        createColumnTreeSelect({
            title: () => i18n.global.t("views.register.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: callDepartment,
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { name: "refDepartment.id" },
            width: 200
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.user.refJobPosition"),
            dataIndex: "refJobPosition.nameTh",
            inputProp: () => ({ list: callJobPosition, optLabel: "nameTh" }),
            search: { name: "refJobPosition.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.user.fullNameTh"),
            dataIndex: "fullNameTh"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.user.refDocumentTypePerson"),
            dataIndex: "refDocumentTypePerson.value",
            inputProp: () => ({ list: callDocumentTypePerson, optLabel: "value" }),
            search: { name: "refDocumentTypePerson.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.user.idCard"),
            dataIndex: "idCard"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.user.refOfficerType"),
            dataIndex: "refOfficerType.value",
            inputProp: () => ({ list: callOfficerType, optLabel: "value" }),
            search: { name: "refOfficerType.id" }
        }),
        createColumnDate({
            title: () => i18n.global.t("views.company.mgt.tab.approveDate"),
            dataIndex: "refLastRequest7.lastStatus.approve.0.statusDatetime",
            align: "center",
            width: 130
        }),
        createColumnInlineSelect({
            title: () => i18n.global.t("model.user.refOfficerLv"),
            dataIndex: "refOfficerLv",
            inputProp: () => ({ list: callOfficerLv, optLabel: "value" }),
            search: { name: "refOfficerLv.id" },
            customRenderInputProp: ({ record }) => ({
                list: callOfficerLv,
                optLabel: "value",
                "onUpdate:value": value => {
                    record.refOfficerLv = value;
                    const { onClickRequest, callCustomsSave } = require("./user.logic");
                    onClickRequest({ callRequest: () => callCustomsSave({ form: record }) });
                },
                allowClear: false
            }),
            width: 200
        }),
        createColumnInlineSelect({
            title: () => i18n.global.t("model.user.refStatus"),
            dataIndex: "refStatus",
            inputProp: () => ({ list: callUserStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            customRenderInputProp: ({ record }) => ({
                list: callUserStatus,
                optLabel: "value",
                "onUpdate:value": value => {
                    record.refStatus = value;
                    const { onClickRequest, callCustomsSave } = require("./user.logic");
                    onClickRequest({ callRequest: () => callCustomsSave({ form: record }) });
                },
                allowClear: false
            })
        })
    ];
    return columns;
};
